import * as React from "react";

import { ILeanSvgIconWithColor } from "../ILeanSvgIconWithColor";

export const arrows_up_down_small: React.FunctionComponent<ILeanSvgIconWithColor> = ({ iconColor, ...rest }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...rest}>
      <path
        fill="none"
        stroke={iconColor}
        d="M7.5,3.75 L7.5,19 M11.3521,7.644 L7.5001,3.75 L3.6571,7.646 M16.502,18.249
        L16.502,2.999 M12.6494,14.3555 L16.5024,18.2495 L20.3444,14.3525"
      />
    </svg>
  );
};
